import Vue from 'vue'
import { getApiBasePath } from '@/constants'

export const fetchPublicConfig = async (params) => {
  const response = await Vue.axios.post('https://entity.sparknt.cn/partner/fetchPubConfig', params)
  return response.data
}

export const getUserList = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/user/partnerListV2`, params)
  return response.data
}

export const fetchWxUser = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/user/fetchWxUser`, params)
  return response.data
}

export const fetchUserInfo = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/user/fetchUserInfo`, params)
  return response.data
}

export const fetchRoleCodeList = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/user/fetchRoleCodeList`, params)
  return response.data
}

export const getPartner = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/user/getPartner`, params)
  return response.data
}

export const bindPartner = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/user/bindPartner`, params)
  return response.data
}

export const bindAlliance = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/user/bindAlliance`, params)
  return response.data
}

export const sendVcode = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/user/sendVcode`, params)
  return response.data
}

export const getCallLineConfig = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/user/callLineConfig`, params)
  return response.data
}
